import {Component, OnInit, OnDestroy} from "@angular/core";
import {Client} from "src/app/services/API/client";
import {toastrService} from "src/app/services/ux/toastr.service";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
    templateUrl: "./tracking-details.component.html",
    styleUrls: ["./tracking-details.component.css"]
})
export class TrackingDetailsComponent implements OnInit, OnDestroy {

    trackers; // mban te dhenat qe jane bere tracking codit
    trackingNr: string; // numri i tracking
    paramsSubscription: Subscription;
    loading;

    constructor(
        private client: Client,
        public toastr: toastrService,
        private route: ActivatedRoute,
        private translateService: TranslateService
    ) {
    }

    ngOnInit() {
        //merr parametrin trackingnr nga fa
        this.paramsSubscription = this.route.params.subscribe((params) => {
            this.trackingNr = params["trackId"];
            this.getTrackingDetails();
        });

    }


    ngOnDestroy() {
        this.paramsSubscription.unsubscribe();
    }

    // Get tracking details from the API
    getTrackingDetails() {
        this.loading = true;
        //stringu qe therritet nga funksioni
        let apiStr: string = "api/mailItemEvents/getTrackApi" + "/" + this.trackingNr;

        //API call
        this.client.get(apiStr)

            //Get response and attach it to trackers
            .then((res: any) => {
                if (res == "Pakoja nuk ekziston") {
                    this.toastr.error(res);
                } else if (res.length === 0) {
                    this.toastr.info(this.translateService.instant("Tracking.NoBarcodeEvent"));
                } else {
                    this.trackers = res;
                }
                this.loading = false;
            })

            //Catch errors
            .catch((err: any) => {
                if (err.error == "package_not_found") {
                    this.toastr.warning(this.translateService.instant("Tracking.PackageNotFound"));
                }
                this.loading = false;
                return err;
            });
    }
}
